import { Injectable } from '@angular/core';
import {
  DESKTOP_FALLBACK_URL,
  DL_CAMPAIGN_URL,
  DL_DELIVERY_URL
} from '../utils/consts';

@Injectable({
  providedIn: 'root',
})
export class DeepLinkService {
  constructor() {}

  public deeplinkRedirect(campaignId: string, isDelivery = false): void {
    let deepLinkUrl = `${
      isDelivery ? DL_DELIVERY_URL : DL_CAMPAIGN_URL
    }${campaignId}`;

    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any).opera;

    if (this.isIOS(userAgent)) {
      deepLinkUrl += '&store=ios';
      window.location.href = deepLinkUrl;
    } else if (this.isAndroid(userAgent)) {
      deepLinkUrl += '&store=android';
      window.location.href = deepLinkUrl;
    } else {
      window.open(DESKTOP_FALLBACK_URL, '_blank');
      return;
    }
  }

  public isIOS(userAgent: string) {
    // A checagem `!(window as any).MSStream` é para evitar falsos positivos no IE11
    return /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
  }

  public isAndroid(userAgent: string) {
    return /android/i.test(userAgent);
  }
}
